import { useTilt } from "@/hooks/useTilt";
import { MRLogo } from "@/components/ui-custom/MRLogo";
import { content } from "@/lib/content";
import { ArrowRight, PenTool, Code2, Gauge } from "lucide-react";

const b = content.frame3.browser;
const icons = [PenTool, Code2, Gauge];

export const BrowserCard = () => {
  const tilt = useTilt(7);
  return (
    <div
      ref={tilt}
      className="w-full max-w-md will-change-transform"
      style={{ transformStyle: "preserve-3d" }}
    >
      <div className="overflow-hidden rounded-2xl border border-border bg-card shadow-float">
        {/* browser chrome */}
        <div className="flex items-center gap-2 border-b border-border bg-secondary/60 px-4 py-3">
          <span className="h-2.5 w-2.5 rounded-full bg-destructive/80" />
          <span className="h-2.5 w-2.5 rounded-full bg-warning/90" />
          <span className="h-2.5 w-2.5 rounded-full bg-success/80" />
          <div className="ml-3 flex-1">
            <div className="mx-auto w-max rounded-md bg-background px-3 py-1 text-[11px] text-muted-foreground">
              {b.url}
            </div>
          </div>
        </div>

        {/* mini site */}
        <div className="p-5">
          <div className="flex items-center justify-between">
            <div className="text-primary">
              <MRLogo className="w-[37px]" />
            </div>
            <div className="hidden items-center gap-3 sm:flex">
              {b.menu.map((m) => (
                <span key={m} className="text-[10px] text-muted-foreground">
                  {m}
                </span>
              ))}
              <span className="rounded-md bg-primary px-2.5 py-1 text-[10px] font-medium text-primary-foreground">
                {b.cta}
              </span>
            </div>
          </div>

          <div className="mt-6">
            <span className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground">
              {b.kicker}
            </span>
            <h3 className="mt-2 font-display text-2xl font-semibold leading-tight text-foreground">
              {b.heroTitle}
            </h3>
            <p className="mt-2 text-xs leading-relaxed text-muted-foreground">
              {b.heroText}
            </p>
            <div className="mt-4 flex items-center gap-3">
              <span className="inline-flex items-center gap-1.5 rounded-md bg-primary px-3 py-1.5 text-[11px] font-medium text-primary-foreground">
                {b.heroBtn}
                <ArrowRight className="h-3 w-3" />
              </span>
              {/* mini bar chart */}
              <div className="ml-auto flex h-10 items-end gap-1">
                {[40, 65, 50, 80, 95].map((h, i) => (
                  <span
                    key={i}
                    className="w-1.5 rounded-sm bg-primary/70"
                    style={{ height: `${h}%` }}
                  />
                ))}
              </div>
            </div>
          </div>

          <div className="mt-6 border-t border-border pt-4">
            <p className="text-center text-[11px] font-medium text-foreground">
              {b.sectionTitle}
            </p>
            <div className="mt-3 grid grid-cols-3 gap-2">
              {b.cards.map((c, i) => {
                const Icon = icons[i];
                return (
                  <div
                    key={c.title}
                    className="rounded-lg border border-border bg-secondary/40 p-2.5"
                  >
                    <Icon className="h-3.5 w-3.5 text-primary" />
                    <p className="mt-1.5 text-[10px] font-semibold text-foreground">
                      {c.title}
                    </p>
                    <p className="mt-0.5 text-[9px] leading-snug text-muted-foreground">
                      {c.desc}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
